import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { QUICK_FILTER_TIN_URL } from './apiUrlConstants';

const _httpService = new HttpService();
const cache = new Map();

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}


export const getQuickFilterTinData = async (payload: any) => {
  const url = QUICK_FILTER_TIN_URL;
  try {
    const responseData: any = await _httpService.push(url, payload);
    return responseData;
  } catch {
    return null;
  }
};